import { Box, Switch, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'

import { ReactComponent as AirImpactLogo } from '../assets/img/logo/airimpact-logo-colorful-with-text.svg'
import { CheckoutScreen } from '../components/payment-service/CheckoutScreen'
import { TierComponent } from '../components/TierComponent'
import { useTierSelectionContext, PlanData } from '../hooks/useTierSelection'
import { useWorkspaceContext } from '../hooks/useWorkspace'
import BgOrnament from '../icons/bg-ornament.svg'
import { ReactComponent as IconLeaf } from '../icons/leaf.svg'

function TierSelectionComponent() {
  const { subscriptionPlansDetails, subscriptionPlans, getSubscriptionPlans } = useTierSelectionContext()
  const { selectedWorkspaceDetails, subscriptionPlansIsLoadedRef } = useWorkspaceContext()

  const [isCheckoutScreen, setIsCheckoutScreen] = useState(false)
  const [selectedPlan, setSelectedPlan] = useState<PlanData>()
  const [checked, setChecked] = useState(false)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked)
  }

  const isCanceledSubscription = Boolean(
    !selectedWorkspaceDetails.subscription?.isEligibleForTrial && !selectedWorkspaceDetails?.subscription?.data,
  )

  useEffect(() => {
    if (!subscriptionPlansIsLoadedRef.current) {
      const getData = async () => {
        await getSubscriptionPlans()
      }
      getData()
    }
  }, [subscriptionPlansIsLoadedRef.current])

  return (
    <Box sx={{ padding: '54px 72px 120px', backgroundColor: '#f5f8f6' }}>
      {isCheckoutScreen && selectedPlan && (
        <CheckoutScreen
          isTierView
          checked={checked}
          setChecked={setChecked}
          onClose={() => {
            setIsCheckoutScreen(false)
            setSelectedPlan(undefined)
          }}
          selectedPlan={selectedPlan}
          setIsCheckoutScreen={setIsCheckoutScreen}
        />
      )}

      <Box
        sx={{
          position: 'fixed',
          left: 0,
          bottom: 0,
          width: '517px',
          height: '210px',
          zIndex: 1,
          backgroundImage: `url(${BgOrnament})`,
          backgroundPosition: 'left bottom',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
        }}
      />

      <Box sx={{ position: 'relative', zIndex: 2 }}>
        <AirImpactLogo />

        <Box sx={{ marginTop: 5.5 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
            <IconLeaf style={{ margin: '0 auto' }} />

            <Typography variant="display5" color="primary.800 " mt={1} mb={isCanceledSubscription ? 3 : 2}>
              Choose a plan that works for you
            </Typography>

            {!isCanceledSubscription && (
              <Typography
                variant="body1"
                color="grey.500"
                mb={3}
                sx={{
                  '& span': { color: 'grey.700', fontWeight: 500 },
                  '& span::first-letter': { textTransform: 'uppercase' },
                }}
              >
                Pick a plan to start your 30 days free trial — no credit card required.
                <br />
                Cancel anytime before the trial ends.
              </Typography>
            )}

            <Box sx={{ display: 'flex', alignItems: 'center', marginX: 'auto', marginBottom: 5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', marginRight: 1 }}>
                <Typography variant="subtitle1" color="grey.600">
                  Billed Monthly
                </Typography>
                <Switch checked={checked} onChange={handleChange} inputProps={{ 'aria-label': 'controlled' }} />
                <Typography variant="subtitle1" color="grey.600">
                  Billed Yearly
                </Typography>
              </Box>

              <Typography
                variant="body1"
                color="secondary.700"
                sx={{
                  paddingY: 0.25,
                  paddingX: 1.25,
                  fontWeight: 500,
                  backgroundColor: 'secondary.50',
                  borderRadius: '16px',
                }}
              >
                Save 20%
              </Typography>
            </Box>
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 1.5 }}>
            {subscriptionPlansDetails?.map((data) => {
              const plan = subscriptionPlans.find((subscriptionPlan) => data.plan === subscriptionPlan.plan)

              return plan ? (
                <Box key={data.plan}>
                  <TierComponent
                    {...data}
                    selectedInterval={checked ? 'year' : 'month'}
                    planObject={plan}
                    onTierClick={() => {
                      setSelectedPlan(plan)
                      setIsCheckoutScreen(true)
                    }}
                  />
                </Box>
              ) : (
                ''
              )
            })}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default function () {
  return <TierSelectionComponent />
}
